<template>
  <div class="ai-tab-nav">
    <div class="ai-tab-list">
      <div v-for="t in tabs" :key="t.name"
        :class="['ai-tab', { active: current === t.name }]"
        @click="go(t.name)">
        <i :class="t.icon" style="margin-right:6px"></i>
        {{ t.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiTabNav',
  data() {
    return {
      tabs: [
        { name: 'aiRule',       label: '规则库',     icon: 'el-icon-document' },
        { name: 'aiCheckItem',  label: '检查项',     icon: 'el-icon-tickets' },
        { name: 'aiDict',       label: '参数配置',   icon: 'el-icon-setting' },
        { name: 'aiLlm',        label: '大模型',     icon: 'el-icon-cpu' },
        { name: 'aiAuditTask',  label: '审核任务',   icon: 'el-icon-data-line' }
      ]
    };
  },
  computed: {
    current() {
      return this.$route.name;
    }
  },
  methods: {
    go(name) {
      if (this.current !== name) {
        this.$router.push({ name });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-tab-nav {
  background: #fff;
  padding: 12px 20px 0 20px;
  border-bottom: 1px solid #ebeef5;

  .ai-tab-list {
    display: flex;
    gap: 6px;
  }

  .ai-tab {
    padding: 8px 18px;
    cursor: pointer;
    border-radius: 8px 8px 0 0;
    color: #606266;
    font-size: 14px;
    transition: all 0.15s;
    border: 1px solid transparent;
    border-bottom: none;
    background: #f5f7fa;

    &:hover {
      color: #409EFF;
      background: #ecf5ff;
    }

    &.active {
      color: #409EFF;
      background: #fff;
      border-color: #ebeef5;
      font-weight: 600;
      position: relative;
      top: 1px;
    }
  }
}
</style>
